import { useCallback, useEffect } from 'react'
import { notificacaoStore } from '@/store/notificacaoStore'
import { notificacaoService } from '@/services/notificacaoService'

// Evita o bug em que subscrever ao store inteiro invalida os useCallback a cada
// mutação, re-disparando o useEffect e entrando em loop infinito de /contagem.
// As funções usam getState/setState direto → dependências vazias e estáveis.
export const useNotificacoes = () => {
  const notificacoes = notificacaoStore((s) => s.notificacoes)
  const naoLidas = notificacaoStore((s) => s.naoLidas)
  const total = notificacaoStore((s) => s.total)
  const isLoading = notificacaoStore((s) => s.isLoading)

  const carregarNotificacoes = useCallback(async (page: number = 0, size: number = 10) => {
    const store = notificacaoStore.getState()
    try {
      store.setLoading(true)
      const response = await notificacaoService.listar(page, size)
      store.setNotificacoes(response.content)
      store.setTotal(response.totalElements)
    } catch (error) {
      console.error('Erro ao carregar notificações:', error)
    } finally {
      store.setLoading(false)
    }
  }, [])

  const carregarContagem = useCallback(async () => {
    const store = notificacaoStore.getState()
    try {
      const response = await notificacaoService.obterContagem()
      store.setNaoLidas(response.naoLidas)
      store.setTotal(response.total)
    } catch (error) {
      console.error('Erro ao carregar contagem de notificações:', error)
    }
  }, [])

  const marcarComoLida = useCallback(
    async (id: string) => {
      const store = notificacaoStore.getState()
      try {
        await notificacaoService.marcarLida(id)
        store.marcarLida(id)
        await carregarContagem()
      } catch (error) {
        console.error('Erro ao marcar notificação como lida:', error)
      }
    },
    [carregarContagem]
  )

  const marcarTodasComoLidas = useCallback(async () => {
    const store = notificacaoStore.getState()
    try {
      await notificacaoService.marcarTodasLidas()
      store.setNotificacoes(store.notificacoes.map((n) => ({ ...n, lida: true })))
      await carregarContagem()
    } catch (error) {
      console.error('Erro ao marcar todas as notificações como lidas:', error)
    }
  }, [carregarContagem])

  useEffect(() => {
    carregarContagem()
    const interval = setInterval(carregarContagem, 60000) // a cada minuto
    return () => clearInterval(interval)
  }, [carregarContagem])

  return {
    notificacoes,
    naoLidas,
    total,
    isLoading,
    carregarNotificacoes,
    carregarContagem,
    marcarComoLida,
    marcarTodasComoLidas,
  }
}
